export default {"src":"/_next/static/media/facebook.adbfaff7.svg","height":667,"width":667,"blurWidth":0,"blurHeight":0};